import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe, HaveKeysPipe, NoSpacePipe, NumberPipe, TimePipe } from './pipes/pipes.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTPInterceptorService } from './services/http-interceptor.service';
import { SortableDirective } from './directives/sortable.directive';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { NgChartsModule } from 'ng2-charts';
import { CountUpModule } from 'ngx-countup';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoginComponent } from './components/auth/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { MenuAddComponent } from './components/menu/menu-add/menu-add.component';
import { MenuEditComponent } from './components/menu/menu-edit/menu-edit.component';
import { MenuViewComponent } from './components/menu/menu-view/menu-view.component';
import { UserViewComponent } from './components/user/user-view/user-view.component';
import { UserAddComponent } from './components/user/user-add/user-add.component';
import { UserEditComponent } from './components/user/user-edit/user-edit.component';
import { UserDetailComponent } from './components/user/user-detail/user-detail.component';
import { MemberViewComponent } from './components/member/member-view/member-view.component';
import { MemberDetailComponent } from './components/member/member-detail/member-detail.component';
import { ReportComponent } from './components/report/report.component';
import { DccsViewComponent } from './components/dccs/dccs-view/dccs-view.component';
import { DccsAddComponent } from './components/dccs/dccs-add/dccs-add.component';
import { DccsEditComponent } from './components/dccs/dccs-edit/dccs-edit.component';
import { DccsDetailComponent } from './components/dccs/dccs-detail/dccs-detail.component';
import { StroopViewComponent } from './components/stroop/stroop-view/stroop-view.component';
import { StroopAddComponent } from './components/stroop/stroop-add/stroop-add.component';
import { StroopEditComponent } from './components/stroop/stroop-edit/stroop-edit.component';
import { InfoViewComponent } from './components/info/info-view/info-view.component';
import { InfoAddComponent } from './components/info/info-add/info-add.component';
import { InfoEditComponent } from './components/info/info-edit/info-edit.component';
import { InfoDetailComponent } from './components/info/info-detail/info-detail.component';
import { CantabViewComponent } from './components/cantab/cantab-view/cantab-view.component';
import { CantabAddComponent } from './components/cantab/cantab-add/cantab-add.component';
import { CantabEditComponent } from './components/cantab/cantab-edit/cantab-edit.component';
import { WppsiViewComponent } from './components/wppsi/wppsi-view/wppsi-view.component';
import { WppsiAddComponent } from './components/wppsi/wppsi-add/wppsi-add.component';
import { WppsiEditComponent } from './components/wppsi/wppsi-edit/wppsi-edit.component';
import { ImageViewComponent } from './components/image/image-view/image-view.component';
import { ImageEditComponent } from './components/image/image-edit/image-edit.component';
import { CantabAudioComponent } from './components/cantab/cantab-audio/cantab-audio.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';

@NgModule({
    declarations: [
        AppComponent,
        DatePipe,
        TimePipe,
        NumberPipe,
        HaveKeysPipe,
        NoSpacePipe,
        SortableDirective,
        AutoFocusDirective,
        LoginComponent,
        AvatarComponent,
        BreadcrumbComponent,
        NavbarComponent,
        SidenavComponent,
        DashboardComponent,
        MenuAddComponent,
        MenuEditComponent,
        MenuViewComponent,
        UserViewComponent,
        UserAddComponent,
        UserEditComponent,
        UserDetailComponent,
        MemberViewComponent,
        MemberDetailComponent,
        ReportComponent,
        DccsViewComponent,
        DccsAddComponent,
        DccsEditComponent,
        DccsDetailComponent,
        StroopViewComponent,
        StroopAddComponent,
        StroopEditComponent,
        InfoViewComponent,
        InfoAddComponent,
        InfoEditComponent,
        InfoDetailComponent,
        CantabViewComponent,
        CantabAddComponent,
        CantabEditComponent,
        WppsiViewComponent,
        WppsiAddComponent,
        WppsiEditComponent,
        ImageViewComponent,
        ImageEditComponent,
        CantabAudioComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgbModule,
        NgSelectModule,
        ToastrModule.forRoot(),
        NgChartsModule,
        CountUpModule,
        NgxDaterangepickerMd.forRoot()
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HTTPInterceptorService,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
